export const LANG_ENUM  = {
  RU: "ru",
  EN: "en",
  CN: "cn"
};

export const HTML_LANGUAGES = Object.freeze({
  [LANG_ENUM.RU]: "ru",
  [LANG_ENUM.EN]: "en",
  [LANG_ENUM.CN]: "zh-CN",
});

export const LANGS = [
  {key:LANG_ENUM.RU, locale: "ruRU", label: "Русский"},
  {key:LANG_ENUM.EN, locale: "enUS", label: "English"},
  {key:LANG_ENUM.CN, locale: "zhCN", label: "中文"},
];

export function getHtmlLanguage(language) {
  return HTML_LANGUAGES[language] || HTML_LANGUAGES[LANG_ENUM.RU];
}
